import React, { ReactNode, useContext } from "react";
import { observer } from "mobx-react-lite";
import { Flex, Divider } from "@fluentui/react-northstar";
import styles from "./entityDetailsItem.module.scss";
import { constants } from "shared/constants";
import { RegularText } from "shared/components";
import { ResizerContext } from "shared/stores/resizeStore/ResizerContext";

export interface EntityDetailsItemProps {
    label: string;
    wrap?: boolean;
    content?: ReactNode;
}

export const EntityDetailsItem: React.FC<EntityDetailsItemProps> = observer((props) => {
    const resizeContext = useContext(ResizerContext);
    const isMobile = resizeContext.windowWidth < constants.view360MobileDeviceWidthPx;

    const shouldWrap = () => {
        return props.wrap || isMobile;
    };

    return (
        <Flex column>
            <Flex fill vAlign="center" column={shouldWrap()} className={styles.container}>
                <RegularText
                    isLabel
                    className={shouldWrap() ? styles.labelWrapped : styles.label}
                    content={props.label}
                />
                <div className={shouldWrap() ? "" : styles.value}>
                    {props.content ?? <RegularText content={constants.noValue} />}
                </div>
            </Flex>
            <Divider />
        </Flex>
    );
});
